import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import {
  withMobileContext,
  WithMobileContextProps,
} from '@wix/da-react-context/pkg/MobileContext';
import Grid from '../../../Grid';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import s from './TierGrid.scss';

export interface Props {
  tiers: PapiDeviation[];
  tierRenderer: ({ index, width }) => React.ReactNode;
  cookieType: MeasuredCookieType;
  isTierPromotion?: boolean;
}

export class TierGrid extends React.Component<Props & WithMobileContextProps> {
  render() {
    const { tiers, cookieType, isTierPromotion, isMobile } = this.props;

    if (!tiers) {
      return null;
    }

    const breakpoints = isTierPromotion
      ? [{ maxWidth: 9999, elementWidth: 270, elementHeight: 147 }]
      : [{ maxWidth: 9999, elementWidth: 360, elementHeight: 330 }];

    return (
      <Grid
        className={s['root']}
        breakpoints={breakpoints}
        cookieType={cookieType}
        elementCount={tiers.length}
        getElementId={this.getTierId}
        renderElement={this.renderTier}
        spacing={isMobile ? 10 : 16}
        enableScrollOptim={false}
      />
    );
  }

  getTierId = (index: number) => {
    const { tiers = [] } = this.props;
    const item = tiers[index];
    return item.deviationId;
  };

  renderTier = ({ style, width, index }) => {
    const { tierRenderer } = this.props;
    return <div style={style}>{tierRenderer({ index, width })}</div>;
  };
}

export default withMobileContext(TierGrid);
